import React from 'react';
import { useTranslation } from 'react-i18next';
import { Preloader } from '../Preloader';

export const Loading = () => {
  const { t } = useTranslation();

  // const onAuth = async () => {
  //   // async request to auth user by photo
  //   // const req = await new Promise((reslove) => setTimeout(reslove, 2000));
  //   // set("userSuccess", { userData: {} }); transfer user data if user founded by second argument in function
  //   // set("userFailture"); just show user failture screen if user not found
  // };

  // useEffect(() => {
  //   fromQr && onAuth();
  // }, [fromQr]);

  return (
    <>
      {/*{fromQr && (*/}
      {/*  <>*/}
      {/*    <h1 className="widget-title">Enface ID</h1>*/}
      {/*    <p className="widget-subtitle">{t('about')}</p>*/}
      {/*  </>*/}
      {/*)}*/}
      <div className="widget-logo">
        <Preloader />
        <p className="widget-loading-text">{t('loading')}</p>
      </div>
    </>
  );
};
